import { Icon, Typography } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useGetUser, useSetOrganization } from '@hero/services/organization-service/hooks';
import { getRedirectUrl } from '@hero/utils';

import * as S from './style';

export const SelectOrganizationTemplate = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { mutateAsync: updateOrganization } = useSetOrganization();
  const { data: { email, organizations } = {} } = useGetUser();
  const params = new URLSearchParams(window.location.search);
  const externalSource = params.get('externalSource');
  const redirect = params.get('redirect');

  const handleOrganizationSelection = async organizationCode => {
    await updateOrganization(organizationCode);
    const redirectUrl = getRedirectUrl(redirect, { externalSource });

    navigate(redirectUrl.pathname + redirectUrl.search);
  };

  return (
    <S.SelectOrganizationTemplate>
      <Typography variant="subtitle3Bold">{t('selectOrganization')}</Typography>
      <S.OrganizationListNotice>
        <Typography variant="body2" emphasis="weak">
          {t('organizationsFor')}
        </Typography>
        <Typography variant="body2Bold" emphasis="weak">
          {email}
        </Typography>
      </S.OrganizationListNotice>
      <S.OrganizationList>
        {organizations?.length ? (
          organizations?.map(item => (
            <S.OrganizationListItem
              type="button"
              onClick={() => handleOrganizationSelection(item.code)}
              key={item.code}
            >
              <Typography variant="body2Bold" lineClamp={1}>
                {item.displayName}
              </Typography>
              <Icon name="next" />
            </S.OrganizationListItem>
          ))
        ) : (
          <S.OrganizationNoResult>{t('noResult')}.</S.OrganizationNoResult>
        )}
      </S.OrganizationList>
    </S.SelectOrganizationTemplate>
  );
};
